import * as React from 'react';

import { UserNotificationSettingsLayer } from '../../models/UserNotificationSettingsLayer';
import { UserNotificationSettingsForm } from './UserNotificationsSettingsForm';

export const UserNotificationsUserSettings = () => (
  <UserNotificationSettingsForm layer={UserNotificationSettingsLayer.User} />
);

export const UserNotificationsSiteSettings = () => (
  <UserNotificationSettingsForm layer={UserNotificationSettingsLayer.Site} />
);